import { OPERATIONS_SECTIONS,PROGRAM_SECTIONS } from '@ekhodealer/ekho-common';

import type { Section } from '@ekhodealer/ekho-common';

import { AssemblyServiceForm } from '../services-forms/operations/AssemblyServiceForm';
import { DeliveryServiceForm } from '../services-forms/operations/DeliveryServiceForm';
import { FreightServiceForm } from '../services-forms/operations/FreightServiceForm';
import { InspectionServiceForm } from '../services-forms/operations/InspectionServiceForm';
import { PickupServiceForm } from '../services-forms/operations/PickupServiceForm';
import { RegistrationServiceForm } from '../services-forms/operations/RegistrationServiceForm';
import { SaleServiceForm } from '../services-forms/operations/SaleServiceForm';
import { TitlingServiceForm } from '../services-forms/operations/TitlingServiceForm';
import { ProgramOwnerCheckoutSection } from '../services-forms/program/CheckoutSection';
import { ProgramOwnerPreorderSection } from '../services-forms/program/PreorderSection';

import { DefaultSection } from './DefaultSection';

/**
 * Maps a Section to its dedicated form component(s).
 * Falls back to DefaultSection for sections without dedicated forms.
 */
export function SectionContent({ section }: { section: Section }) {
	switch (section) {
		// Program sections
		case PROGRAM_SECTIONS.CHECKOUT:
			return <ProgramOwnerCheckoutSection />;
		case PROGRAM_SECTIONS.PREORDER:
			return <ProgramOwnerPreorderSection />;

		// Operations sections
		case OPERATIONS_SECTIONS.SALE:
			return <SaleServiceForm />;
		case OPERATIONS_SECTIONS.DELIVERY:
			return <DeliveryServiceForm />;
		case OPERATIONS_SECTIONS.PICKUP:
			return <PickupServiceForm />;
		case OPERATIONS_SECTIONS.ASSEMBLY:
			return <AssemblyServiceForm />;
		case OPERATIONS_SECTIONS.INSPECTION:
			return <InspectionServiceForm />;
		case OPERATIONS_SECTIONS.TITLING:
			return <TitlingServiceForm />;
		case OPERATIONS_SECTIONS.REGISTRATION:
			return <RegistrationServiceForm />;
		case OPERATIONS_SECTIONS.FREIGHT:
			return <FreightServiceForm />;

		// Domains and other sections — no dedicated forms yet
		default:
			return <DefaultSection section={section} />;
	}
}
